import { type IconButtonProps } from '@pets-ui/IconButton/IconButton'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { CloseLarge } from '@pets-ui/icons'

export type IconButtonDeleteItemProps = IconButtonProps

export const IconButtonDeleteItem = (props: IconButtonDeleteItemProps) => {
  return (
    <IconButton variant="text" color="grey" fontSize={14} {...props}><CloseLarge /></IconButton>
  )
}
